var windowWidth=0
$(window).resize(function(){
  if(windowWidth!=$(window).width()){
    windowWidth=$(window).width()
    if($(window).width()>1200){
      $('.header .toggle').removeClass('active');
      $('.header_box>ul').show();
      $('.header>.header_box>ul').addClass('header_nav');
      $('.header>.header_box>ul>li').removeClass('active');
      $('.header .header_nav li').hover(function(){
        $(this).addClass('active');
        $(this).find('.menu').show();
        $(this).siblings().removeClass('active').find('.menu').hide();
      })
      $('.header').mouseleave(function(){
        $('.header .header_nav li').removeClass('active');
        $(this).find('.menu').hide();
      })
    }else{
      $('.header_box>ul').hide();
      $('.header .toggle').removeClass('active');
      $('.header .header_box li').unbind();
      $('.header').unbind();
      $('.header>.header_box>ul').removeClass('header_nav');
      $('.header>.header_box>ul>li').click(function(){
        $(this).toggleClass('active');
      });
    }
  }
});
$(window).resize();
$('.header_box .toggle').click(function(){
    $(this).toggleClass('active');
    $('.header_box>ul').toggle();
});

//系统识别
var u = navigator.userAgent;
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
function system_confirm(){var userAgentInfo = navigator.userAgent;if(userAgentInfo.indexOf("Win")>-1){return "win"}else if(userAgentInfo.indexOf("Mac")>-1){return "mac"}};function device_confirm(){var userAgentInfo = navigator.userAgent;var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];var flag = true;for (var v = 0; v < Agents.length; v++) {if (userAgentInfo.indexOf(Agents[v]) > 0) {flag = false;break;}}return flag;};
var device_id,isMac;
if(device_confirm()==true){device_id=true}
else if(device_confirm()==false){device_id=false}else{};
if(system_confirm()=="mac"&&device_confirm()){isMac=true}
else if(system_confirm()=="win"&&device_confirm()){isMac=false}
else if(isiOS&&device_confirm()==false){isMac=true}
if (isMac == true && device_id) {
  $('.mac_btn_box').css({"display": "-webkit-box","display":"-webkit-flex","display":"flex"});
  $('.mac_btn').css({"display":"block"});
  $('.mac_content').css({"display":"block"});
  $('.mac_inline').css({"display":"inline-block"});
  $('.win_inline').css({"display":"none"});
  $('.win_btn_box').css({"display":"none"});
  $('.win_btn').css({"display":"none"});
  $('.win_content').css({"display":"none"});
} else if (!isMac == true && device_id) {
  $('.win_btn_box').css({"display": "-webkit-box","display":"-webkit-flex","display":"flex"});
  $('.win_btn').css({"display":"block"});
  $('.win_content').css({"display":"block"});
  $('.mac_btn_box').css({"display":"none"});
  $('.mac_btn').css({"display":"none"});
  $('.win_inline').css({"display":"inline-block"});
  $('.mac_inline').css({"display":"none"});
  $('.mac_content').css({"display":"none"});
} else if (device_id == false) {
  $('.pc_btn').css({"display":"none"});
  $('.mobile_down').toggle();
  $('.down').toggle();
  if(isAndroid){
    $('.win_btn_box').css({"display": "-webkit-box","display":"-webkit-flex","display":"flex"});
    $('.mac_btn_box').css({"display":"none"});
  }else if(isiOS){
    $('.win_btn_box').css({"display":"none"});
    $('.mac_btn_box').css({"display": "-webkit-box","display":"-webkit-flex","display":"flex"});
  }
};
//Languages
(function(){
  var location_h = window.location.href.split('io')[1];
  console.log(location_h);
  if(location_h!='/'){
    for(var i=0;i<$('.languages a').length;i++){
      if($('.languages a').eq(i).attr('href').indexOf(location_h)>-1){
        // $('.language_icon').css('backgroundPosition',$('.languages a').eq(i).find('i').css('backgroundPosition'));
        $('.other_languages').html('').html($('.languages a').eq(i).html().replace('<i></i>','')).append('<i></i>');
      }
    }
  };
  $('body').on('click',function(){
    $(".languages_mask").removeClass("active");
    $('.other_languages').removeClass('active');
  });
  $(".other_languages").click(function(event){
      event = event || window.event;
      window.event ? event.stopPropagation() : (window.cancelBubble = true);
      $(".languages_mask").toggleClass("active");
      var height = $('.languages_mask').height();
      // if($(window).width()>1200){$('.languages_mask').css('top',-1*height-15);}
      $(this).toggleClass('active');
  });
  $(".languages_mask .close").click(function(event){
      event = event || window.event;
      window.event ? event.stopPropagation() : (window.cancelBubble = true);
      $(".languages_mask").removeClass("active");
      $('.other_languages').removeClass('active');
  });
  $(".languages_mask").click(function(event){
      event = event || window.event;
      window.event ? event.stopPropagation() : (window.cancelBubble = true);
      $(this).removeClass("active");
      $('.other_languages').removeClass('active');
  });
  $(".languages").click(function(event){
      event = event || window.event;
      window.event ? event.stopPropagation() : (window.cancelBubble = true);
      $(this).removeClass("active");
      $('.other_languages').removeClass('active');
  });
  $(".footer .notranslate").attr('href','https://www.anyrec.io/');
})();
// footer
(function(){
  $(".footer_box dt").click(function(){
    $(this).siblings("dd").toggleClass("active");
    $(this).parent("dl").toggleClass("active");
    $(".footer_box dd").not($(this).siblings()).removeClass("active");
    $(".footer_box dl").not($(this).parent("dl")).removeClass("active");
  });
})();
